import React from 'react';
import { motion } from 'framer-motion';

const Footer = ({ contactInfo }) => {
  const currentYear = new Date().getFullYear();

  const footerVariants = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: { duration: 0.8 },
    },
  };

  const linkVariants = {
    hidden: { opacity: 0, y: 10 },
    visible: {
      opacity: 1,
      y: 0,
      transition: { duration: 0.5 },
    },
    hover: { x: 5, color: '#f59e0b' },
  };

  return (
    <motion.footer
      variants={footerVariants}
      initial="hidden"
      whileInView="visible"
      viewport={{ once: true }}
      className="bg-gradient-to-br from-slate-950 via-slate-900 to-slate-950 border-t border-amber-500/20 text-gray-300"
    >
      <div className="max-w-7xl mx-auto px-8 py-16">
        <div className="grid md:grid-cols-4 gap-12 mb-12">
          {/* Brand */}
          <motion.div
            variants={linkVariants}
            className="col-span-1"
          >
            <h3 className="text-2xl font-bold bg-gradient-to-r from-amber-400 to-amber-300 bg-clip-text text-transparent mb-4">
              Ceylon Broker
            </h3>
            <p className="text-sm text-gray-400">
              Your trusted gateway to digital currency trading with transparent pricing and 24/7 support.
            </p>
          </motion.div>

          {/* Quick Links */}
          <motion.div variants={linkVariants} className="col-span-1">
            <h4 className="text-lg font-semibold text-amber-300 mb-4">Quick Links</h4>
            <ul className="space-y-3">
              {['Home', 'Buy Now', 'How It Works', 'FAQ'].map((link) => (
                <li key={link}>
                  <motion.a
                    href="#"
                    variants={linkVariants}
                    whileHover="hover"
                    className="text-sm text-gray-400 hover:text-amber-300 transition-colors"
                  >
                    {link}
                  </motion.a>
                </li>
              ))}
            </ul>
          </motion.div>

          {/* Support */}
          <motion.div variants={linkVariants} className="col-span-1">
            <h4 className="text-lg font-semibold text-amber-300 mb-4">Support</h4>
            <ul className="space-y-3">
              {['Contact Us', 'FAQ', 'Security', 'Privacy Policy'].map((link) => (
                <li key={link}>
                  <motion.a
                    href="#"
                    variants={linkVariants}
                    whileHover="hover"
                    className="text-sm text-gray-400 hover:text-amber-300 transition-colors"
                  >
                    {link}
                  </motion.a>
                </li>
              ))}
            </ul>
          </motion.div>

          {/* Contact Info */}
          <motion.div variants={linkVariants} className="col-span-1">
            <h4 className="text-lg font-semibold text-amber-300 mb-4">Get In Touch</h4>
            <div className="space-y-3 text-sm">
              <p className="flex items-start gap-3">
                <span className="text-amber-400">📧</span>
                <span className="text-gray-400">{contactInfo?.contact_email || 'support@ceylonbroker.com'}</span>
              </p>
              <p className="flex items-start gap-3">
                <span className="text-amber-400">📱</span>
                <span className="text-gray-400">{contactInfo?.contact_phone || '+94-71-123-4567'}</span>
              </p>
              <p className="flex items-start gap-3">
                <span className="text-amber-400">📍</span>
                <span className="text-gray-400">{contactInfo?.contact_address || 'Colombo, Sri Lanka'}</span>
              </p>
            </div>
          </motion.div>
        </div>

        {/* Social Media */}
        <motion.div
          variants={linkVariants}
          className="border-t border-amber-500/20 pt-8 mb-8"
        >
          <div className="flex justify-center gap-6">
            {[
              { icon: '𝕏', label: 'Twitter' },
              { icon: 'f', label: 'Facebook' },
              { icon: 'in', label: 'LinkedIn' },
              { icon: 'IG', label: 'Instagram' },
            ].map((social) => (
              <motion.a
                key={social.label}
                href="#"
                className="w-10 h-10 rounded-full border border-amber-400/30 flex items-center justify-center text-amber-300 hover:bg-amber-400/10 transition-all"
                whileHover={{ scale: 1.1, borderColor: '#fbbf24' }}
                whileTap={{ scale: 0.95 }}
              >
                {social.icon}
              </motion.a>
            ))}
          </div>
        </motion.div>

        {/* Bottom */}
        <motion.div
          variants={linkVariants}
          className="border-t border-amber-500/20 pt-8 text-center text-sm text-gray-500"
        >
          <p className="mb-4">
            <span>© {currentYear} Ceylon Broker. All rights reserved. | </span>
            <motion.a
              href="#"
              whileHover={{ color: '#fbbf24' }}
              className="text-gray-400 hover:text-amber-300 transition-colors"
            >
              Privacy Policy
            </motion.a>
            {' | '}
            <motion.a
              href="#"
              whileHover={{ color: '#fbbf24' }}
              className="text-gray-400 hover:text-amber-300 transition-colors"
            >
              Terms & Conditions
            </motion.a>
          </p>
          <p className="text-xs text-gray-600">
            ⚠️ Digital currency trading involves risk. Please trade responsibly.
          </p>
        </motion.div>
      </div>
    </motion.footer>
  );
};

export default Footer;
